import React from "react";
import "./style.scss";

const TableHeader = ({className, children}) => (
  <div className={`row table-header ${className || ""}`}>{[children]}</div>
);

export default TableHeader;



// WEBPACK FOOTER //
// ./src/components/Table/TableHeader/index.jsx